// eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration
import get from 'lodash/get';
import config from '@nerdwallet/app-config';

import { MARKETPLACE_SERVER_ERROR_MSG, NOTFOUND_ERROR_MSG } from './errors';
import getErrorHandlers from './error-handling';
import { logInfo, logWarn } from './logging-utils';
import { httpClient } from './nw-api-sdk';

const BY_LEGACY_ID = 'by_legacy_id';
const BY_ENTITY_ID = 'by_entity_id';

const getPath = (slug, id) => {
  if (slug === 'credit-cards') {
    return `${BY_LEGACY_ID}/${id}?product_type=credit_cards`;
  }
  if (slug === 'network-links') {
    return `${BY_LEGACY_ID}/${id}`;
  }
  return `${BY_ENTITY_ID}/${id}`;
};

/*
 * Gets redirect details from Marketplace API
 */
export default async ({ category, id, routeVerticalSlug, req, res, store }) => {
  const { handleServerError } = getErrorHandlers({
    req,
    res,
    store,
    service: config.API.BASE_URLS.MARKETPLACE,
  });

  const marketplaceBase = config.API.BASE_URLS.MARKETPLACE;
  const path = getPath(routeVerticalSlug, id);
  const marketplaceRedirectUrl = `${marketplaceBase}/redirect_links/v1/${path}`;
  const fetchArgs = {
    method: 'GET',
    url: marketplaceRedirectUrl,
    serverRequest: req,
  };

  let result;
  try {
    result = await httpClient.fetch(fetchArgs);
  } catch (e) {
    // Request failed (e.g. connectivity issues)
    const connectionError = new Error(
      `${MARKETPLACE_SERVER_ERROR_MSG}: ${e.message}`
    );
    handleServerError({
      product: { category, id },
      error: connectionError,
    });
    throw connectionError;
  }

  const { response, body } = result;
  // Non-404 server errors
  if (body.error && response.statusCode !== 404) {
    const message = get(body, 'error.data.internal_message');
    const type = get(body, 'error.type');
    const serverError = new Error(
      `${MARKETPLACE_SERVER_ERROR_MSG}: [${type}] ${message}`
    );
    handleServerError({
      product: { category, id },
      error: serverError,
    });
    throw serverError;
  } else {
    // Otherwise, return the data. Caller will decide how to handle undefined data
    const { data } = body;
    if (data === undefined) {
      logWarn(req, NOTFOUND_ERROR_MSG, {
        service: config.API.BASE_URLS.MARKETPLACE,
        productId: id,
        category,
        message: get(body, 'error.data.internal_message'),
      });
    } else {
      logInfo(req, 'log-marketplace-response', data);
    }
    return data;
  }
};
